import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { SceneEmail } from '@elem/compCommon/SceneEmail';
import EcoImg from 'eco-design/base/eco-img';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('offgrid');

    return (
        <div className={`off-grid-A ${css['off-grid-A']}`}>
            <div className="img-box">
                <EcoImg
                    pc={'https://websiteoss.ecoflow.com/upload/image/1764749331345/1%20(1).jpg'}
                    h5={'https://websiteoss.ecoflow.com/upload/image/1764749353683/1_768%20(1).jpg'}
                    alt={t('secA_title')}
                />
            </div>
            <div className="text-info">
                <h1 className="title">{t('secA_title')}</h1>
                {/* <p className="desc sub">{t('secA_desc')}</p>
                <a className="btn" href="#off-grid-B">
                    {t('secA_btn')}
                </a> */}
                <SceneEmail theme="white" title={t('secA_title')} type="LIVING_OFF_GRID" />
            </div>
        </div>
    );
}
